"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (variant) { return function (_a) {
    var theme = _a.theme;
    return "font-size: " + theme.fonts[variant].size + ";";
}; });
